/* Vue dependecies */
import Vue from 'vue'
import Router from 'vue-router'
import VueGtm from 'vue-gtm'

/* Layouts */
import Public from '@/layouts/Public'

/* Pages */

import LandingSiniestros from '@/pages/LandingSiniestros'

Vue.use(Router)

const router = new Router({
  base: process.env.ROUTER_BASE,
  routes: [
    {
      path: '/ayuda/siniestros',
      component: Public,
      children: [
        {
          path: '/ayuda/siniestros',
          component: LandingSiniestros
        }
      ]
    },
    {
      path: '/ayuda/siniestros/*',
      component: Public,
      beforeEnter (to, from, next) {
        next('/ayuda/siniestros')
      }
    },
    {
      path: '/siniestros',
      component: Public,
      children: [
        {
          path: '/siniestros',
          component: LandingSiniestros
        }
      ]
    },
    {
      path: '/siniestros/*',
      component: Public,
      beforeEnter (to, from, next) {
        next('/siniestros')
      }
    },
    {
      path: '/ayuda/*',
      component: Public,
      beforeEnter (to, from, next) {
        next('/ayuda/siniestros')
      }
    },
    {
      path: '/*',
      component: Public,
      beforeEnter (to, from, next) {
        next('/siniestros')
      }
    }
  ],
  scrollBehavior () {
    return {x: 0, y: 0}
  },
  mode: 'history'
})

Vue.use(VueGtm, {
  id: process.env.GTM_CODE, // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  // debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js